<template>
  <v-app>
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Connexion</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-alert type="error" text v-if="error != ''">{{
                  error
                }}</v-alert>
                <v-form>
                  <v-text-field
                    label="E-mail"
                    v-model="email"
                    prepend-icon="mdi-account"
                    type="email"
                  ></v-text-field>

                  <v-text-field
                    label="Mot de passe"
                    v-model="password"
                    prepend-icon="mdi-lock"
                    type="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :loading="loading" @click="login"
                  >Valider</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { auth } from "@/firebase";

export default {
  data: () => ({
    email: "",
    password: "",
    error: "",
    loading: false,
  }),
  methods: {
    async login() {
      this.loading = true;
      this.error = "";

      try {
        await auth.signInWithEmailAndPassword(this.email, this.password);
        this.loading = false;
        this.$router.push("dashboard");
      } catch (e) {
        this.loading = false;
        const errorCode = e.code;
        if (errorCode == "auth/wrong-password") {
          this.error = "Mauvais mot de passe.";
        } else if (errorCode == "auth/user-not-found") {
          this.error = "Utilisateur introuvable.";
        } else if (errorCode == "auth/invalid-email") {
          this.error = "Adresse email invalide";
        } else {
          this.error = "Une erreur s'est produite, veuillez rééssayer.";
        }
      }
    },
  },
};
</script>
